export default[
        {
            name: 'OADetailes',
            path: 'OADetailes',
            redirect:{name:'ShenBaoCaiLiao'},
            component: () => import('@/pages/BigData/PatentModule/OADetailes'),
            meta: { title: '详情' },
            props(route) {
                return {
                    id: route.query.id,
                }
            },
            children: [
                {
                    name: 'ShenBaoCaiLiao',
                    path: 'ShenBaoCaiLiao',
                    component: () => import('@/pages/BigData/PatentModule/OADetailes/ShenBaoCaiLiao'),
                    meta: { title: '申报材料' },
                    props(route) {
                        return {
                            id: route.query.id,
                        }
                    },
                },
                {
                    name: 'CPCAnJuanBao',
                    path: 'CPCAnJuanBao',
                    component: () => import('@/pages/BigData/PatentModule/OADetailes/CPCAnJuanBao'),
                    meta: { title: 'CPC案卷包' },
                    props(route) {
                        return {
                            id: route.query.id,
                        }
                    },
                },
                {
                    name: 'TongZhiWenShu',
                    path: 'TongZhiWenShu',
                    component: () => import('@/pages/BigData/PatentModule/OADetailes/TongZhiWenShu'),
                    meta: { title: '通知文书' },
                    props(route) {
                        return {
                            id: route.query.id,
                        }
                    },
                },
            ]
        },
        {
            name: 'reqAll',
            path: 'reqAll',
            component: () => import('@/pages/BigData/PatentModule/replyCase/reqAll'),
            meta: { title: '全部' },
            props(route) {
                return {
                    id: route.query.id,
                }
            },
        },
        {
            name: 'reqToBeDeclared',
            path: 'reqToBeDeclared',
            component: () => import('@/pages/BigData/PatentModule/replyCase/reqToBeDeclared'),
            meta: { title: '待申报' },
            props(route) {
                return {
                    id: route.query.id,
                }
            },
        },
        {
            name: 'reqDeclaring',
            path: 'reqDeclaring',
            component: () => import('@/pages/BigData/PatentModule/replyCase/reqDeclaring'),
            meta: { title: '申报中' },
            props(route) {
                return {
                    id: route.query.id,
                }
            },
        },
        {
            name: 'reqDeclared',
            path: 'reqDeclared',
            component: () => import('@/pages/BigData/PatentModule/replyCase/reqDeclared'),
            meta: { title: '已申报' },
            props(route) {
                return {
                    id: route.query.id,
                }
            },
        },
]